import { X } from 'lucide-react';
import type { ReactNode } from 'react';

interface FilterSummaryChipProps {
  children: ReactNode;
  icon?: ReactNode;
  label?: string;
  removeLabel?: string;
  onRemove: () => void;
}

export function FilterSummaryChip({
  children,
  icon,
  label,
  removeLabel,
  onRemove,
}: FilterSummaryChipProps) {
  return (
    <span className="inline-flex items-center gap-1 rounded-sm border border-gray-200/60 bg-white/50 px-1.5 py-0.5 text-[11px] font-normal text-gray-500">
      {label ? (
        <span className="shrink-0 text-[9px] font-semibold uppercase text-gray-400">
          {label}
        </span>
      ) : icon}
      {children}
      <button
        type="button"
        onClick={onRemove}
        className="ml-0.5 text-gray-300 hover:text-gray-500"
        aria-label={removeLabel ?? `Remove ${label ?? 'filter'}`}
      >
        <X className="h-2.5 w-2.5" />
      </button>
    </span>
  );
}
